import { createApp, defineComponent } from 'vue';
import GridCostCellEditor from './GridCostCellEditor.vue';
import customHelper from '$$helpers/custom';
import globalToast from '$$uiKitComp/toast';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridCostCellEditor);

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder);
      vueInstance = vueApp.mount(placeholder);
    },

    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;
      vueInstance = null;
    },

    set_value(task, id, column, node) {
      vueInstance.value = task.actual_cost;
    },

    get_value(id, column, node) {
      return vueInstance.value;
    },

    is_changed(task, id, column, node) {
      return task.actual_cost !== vueInstance.value;
    },

    is_valid(value, id, column, node) {
      if (!customHelper.testNumber(value)) {
        globalToast.warning(__('grid_number_custom_column_not_valid'));

        return false;
      }

      // varchar(24): JS Number of 22+ digit values becomes 1e+21… and overflows the column
      const normalized = value.toString().replace(',', '.');
      const characterLimit = 24;

      if (normalized.length > characterLimit || /e/i.test(String(+normalized))) {
        globalToast.warning(__('character_limit_grid_costs_columns'));

        return false;
      }

      return true;
    },

    save(id, column, node) {
      const task = instance.getTask(id);
      const value = vueInstance.value.toString().replace(',', '.');

      task.actual_cost = +value;
      instance.updateTask(task.id);
      instance.refreshData(); // recalculate parents
    },

    focus(node) {
    },
  };
}
